<template>
  <div class="app-container">
    <div class="title"><span v-html="$t('message.cuotas.titulo' + tipoEmpresa)"></span></div>
    <v-tabs v-model="tabActive" fixed-tabs color="transparent" slider-color="primary">
      <v-tab key="1"> {{ $t('message.cuotas.elec.tabs.caratula') }}</v-tab>
      <v-tab key="2" :disabled="hayCostesPermanentes">{{
        $t('message.cuotas.elec.tabs.costesPermanentes')
      }}</v-tab>
      <v-tab key="3" :disabled="hayCostesDiv">{{ $t('message.cuotas.elec.tabs.costesDiv') }}</v-tab>

      <v-tab-item key="1">
        <v-card flat>
          <Divider>
            <v-btn flat small class="ayuda" :to="'/cuotas/presentacion-cuota/ayuda' + tipoEmpresa"
              ><v-icon left color="primary">info</v-icon>{{ $t('message.cuotas.instrucciones') }}
            </v-btn>
          </Divider>
          <v-form ref="formDeclaracion" lazy-validation>
            <Divider>{{ $t('message.cuotas.elec.apartados1') }}</Divider>
            <v-container fluid grid-list-xs>
              <v-layout d-inline-flex>
                <v-flex xs6>
                  <v-text-field
                    :label="$t('message.comun.mesDeclaracion')"
                    v-model="periodoDeclaracionText"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <MonthPicker
                    id="mesFacturacion"
                    v-model="form.mesFacturacion"
                    placeholder="mes-año"
                    :pickerOptions="allowedMonths"
                    :label="$t('message.comun.mesFacturacion')"
                  ></MonthPicker>
                </v-flex>
              </v-layout>
            </v-container>

            <Divider>{{ $t('message.cuotas.elec.apartados2') }}</Divider>

            <PeriodosElecCuotas
              id="tblfacturacionTarifas"
              :data="cuotasTarifas"
              :mesFacturacion="form.mesFacturacion"
              :baseCotizacion="baseCotizacionTarifa"
              @modify="modificarPeriodoHandler"
              @remove="removePeriodoHandler"
            ></PeriodosElecCuotas>

            <Divider>{{ $t('message.cuotas.elec.apartados3') }}</Divider>
            <PeriodosElecCuotas
              id="tblfacturacionPeajes"
              :data="cuotasPeajes"
              :mesFacturacion="form.mesFacturacion"
              :baseCotizacion="baseCotizacionPeaje"
              @modify="modificarPeriodoHandler"
              @remove="removePeriodoHandler"
            ></PeriodosElecCuotas>

            <v-layout>
              <v-flex text-xs-center>
                <Boton
                  id="btnPresentar"
                  :onclick="onSubmitAviso"
                  v-if="form.mesFacturacion"
                  :deshabilitado="puedePresentar"
                  >{{ $t('message.cuotas.presentarCuota') }}</Boton
                >
              </v-flex>
            </v-layout>
          </v-form>
        </v-card>
      </v-tab-item>
      <v-tab-item key="2">
        <v-card flat>
          <ResumenCuota
            v-for="count in costesPermanentes"
            :key="count"
            :cuotasDeclaracion="form.cuotasDeclaracion"
            :resumen="form.resumenes[count]"
          ></ResumenCuota>
        </v-card>
      </v-tab-item>
      <v-tab-item key="3">
        <v-card flat>
          <ResumenCuota
            v-for="count in costesDivYSeguridad"
            :key="count"
            :cuotasDeclaracion="form.cuotasDeclaracion"
            :resumen="form.resumenes[count]"
          ></ResumenCuota>
        </v-card>
      </v-tab-item>
    </v-tabs>
    <!-- Ventana modal de alerta -->
    <Modal
      id="modalAvisoCuotaElect"
      :modalShow="showAlert"
      size="400"
      :title="$t('message.cuotas.presentarCuota')"
    >
      <p class="negrita text-xs-center">{{ $t('message.tasas.presentarTasaAviso') }}</p>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="showAlert = false">
          Cancelar
        </v-btn>
        <v-btn color="primary" @click="onSubmit">
          Enviar
        </v-btn>
      </v-card-actions>
    </Modal>
  </div>
</template>
<script>
// General
import { mapActions, mapGetters } from 'vuex';
import redirect from '@/router/redirect';
// Componentes
import { Divider, Boton, MonthPicker, Modal } from '@/components';
import { PeriodosElecCuotas, ResumenCuota } from './components';
// Apis
import { getImpuestoCuota } from '@/api/empresas';
import { newDeclaracion } from '@/api/declaraciones';
// Utils
import { empConst, RESUMEN_CUOTA_INIT } from '@/utils/constants';
import { notificarError } from '@/utils/notification';
import {
  ID_CUOTA_ELEC_EXTRA,
  ID_CUOTA_ELEC_OS,
  ID_CUOTA_ELEC_OM,
  ID_CUOTA_ELEC_INTER,
  ID_CUOTA_ELEC_RECARGO,
  ID_CUOTA_ELEC_MORA,
  PERIODO_CUOTA_INIT,
  BASECOTIZACION_CUOTAS,
  TIPO_DECLARACION_CUOTA
} from './cuotasConst';
import moment from 'moment';
export default {
  name: 'cuotaElec',
  data() {
    return {
      form: {
        idEmpresa: null,
        tipoDeclaracion: TIPO_DECLARACION_CUOTA,
        mesDeclaracion: null,
        mesFacturacion: null,
        cuotasDeclaracion: [],
        resumenes: []
      },
      showAlert: false,
      periodos: [],
      tabActive: 0,
      pickerOptions: {
        disabledDates: {
          from: moment()
            .startOf()
            .date(0)
            .toDate()
        }
      }
    };
  },
  components: {
    Divider,
    Modal,
    Boton,
    MonthPicker,
    PeriodosElecCuotas,
    ResumenCuota
  },
  watch: {
    periodos: {
      handler: function() {
        this.actualizarResumen();
      },
      deep: true
    }
  },
  created() {
    this.setBreadcrumb({
      breadcrumb: [
        { text: 'Inicio', to: '/', disabled: false },
        { text: 'Cuotas', to: '/cuotas', disabled: false },
        {
          text: 'Presentar Cuota Electricidad',
          to: '/cuotas/presentacion-Electricidad',
          disabled: true
        }
      ],
      menuSelected: '/cuotas/presentacion-Electricidad'
    });
    // Se verifica que pueda acceder y se cargan datos iniciales
    this.cargarInfo();
  },
  computed: {
    ...mapGetters(['empresaSelected', 'userNIFCIF', 'userName']),
    tipoEmpresa() {
      return this.empresaSelected.cdtipemp;
    },
    periodoDeclaracionText() {
      return this.form.cuotasDeclaracion
        ? moment(this.form.mesDeclaracion).format('MMMM [de] YYYY')
        : '';
    },
    cuotasTarifas() {
      return this.periodos.filter(item => item.idBaseCo === BASECOTIZACION_CUOTAS.TARIFA);
    },
    cuotasPeajes() {
      return this.periodos.filter(item => item.idBaseCo === BASECOTIZACION_CUOTAS.PEAJE);
    },
    baseCotizacionTarifa() {
      return BASECOTIZACION_CUOTAS.TARIFA;
    },
    baseCotizacionPeaje() {
      return BASECOTIZACION_CUOTAS.PEAJE;
    },
    costesPermanentes() {
      return [0, 1, 2]; // Posiciones Cuotas 10, 20, 30
    },
    costesDivYSeguridad() {
      return [3, 4, 5]; // Posiciones Cuotas 80, 85, 90
    },
    hayCostesPermanentes() {
      return (
        this.form.cuotasDeclaracion.filter(
          item =>
            item.idCuota === ID_CUOTA_ELEC_EXTRA ||
            item.idCuota === ID_CUOTA_ELEC_OS ||
            item.idCuota === ID_CUOTA_ELEC_OM
        ).length === 0
      );
    },
    hayCostesDiv() {
      return (
        this.form.cuotasDeclaracion.filter(
          item =>
            item.idCuota === ID_CUOTA_ELEC_INTER ||
            item.idCuota === ID_CUOTA_ELEC_RECARGO ||
            item.idCuota === ID_CUOTA_ELEC_MORA
        ).length === 0
      );
    },
    puedePresentar() {
      // TODO VALIDAR
      return this.form.cuotasDeclaracion.filter(item => item.cuotaTributaria !== 0).length === 0;
    }
  },
  methods: {
    ...mapActions(['setLoading', 'setBreadcrumb']),
    allowedMonths(val) {
      return (
        moment(val).toDate() <=
        moment()
          .startOf()
          .date(0)
          .toDate()
      );
    },
    cargarInfo() {
      if (this.tipoEmpresa !== empConst.TIPO_ELE) {
        redirect.toError(this.$t('message.errores.tipoNoPermitido'));
      }
      this.setLoading(true);

      // Preparames los resumenes
      for (let y of [
        ID_CUOTA_ELEC_EXTRA,
        ID_CUOTA_ELEC_OS,
        ID_CUOTA_ELEC_OM,
        ID_CUOTA_ELEC_INTER,
        ID_CUOTA_ELEC_RECARGO,
        ID_CUOTA_ELEC_MORA
      ]) {
        let resumen = {};
        Object.assign(resumen, RESUMEN_CUOTA_INIT);
        resumen.id = y;
        resumen.numCuenta = this.$options.filters.datosBancariosIban(resumen.id).replace(/ /g, '');
        this.form.resumenes.push(resumen);
      }

      // Recuperamos el IVA tanto para OM como para OP
      // Payload
      let payload = {
        idEmpresa: this.empresaSelected.idempres,
        idCuota: ID_CUOTA_ELEC_OS
      };
      let self = this;
      let ivaOS = getImpuestoCuota(payload);
      payload.idCuota = ID_CUOTA_ELEC_OM;
      let ivaOM = getImpuestoCuota(payload);
      Promise.all([ivaOS, ivaOM]).then(
        results => {
          // Cargamos datos inciales
          self.form.idEmpresa = this.empresaSelected.idempres;
          self.form.mesDeclaracion = moment()
            .startOf('month')
            .toDate();
          // Se incluye el IVA en OM Y OS
          self.form.resumenes[1].iva = results[0].data;
          self.form.resumenes[2].iva = results[1].data;
          self.setLoading(false);
        },
        error => {
          redirect.toError(error);
          this.setLoading(false);
        }
      );
    },
    modificarPeriodoHandler(payload) {
      var index = this.periodos.findIndex(function(item) {
        return item.idBaseCo === payload.idBaseCo && item.id === payload.id;
      });
      if (index == -1) {
        // Añadirmos a la lista
        this.periodos.push(payload);
      } else {
        //modificamos
        Object.assign(this.periodos[index], payload);
      }
    },
    removePeriodoHandler(payload) {
      var index = this.periodos.findIndex(function(item) {
        return item.idBaseCo === payload.idBaseCo && item.id === payload.id;
      });
      // Borramos
      this.periodos.splice(index, 1);
    },
    actualizarResumen() {
      // Cuotas. Desagremamos un periodo en todas las cuotas.
      this.form.cuotasDeclaracion = [];
      for (let x in this.periodos) {
        for (let y in this.periodos[x].cuotas) {
          if (this.periodos[x].cuotas[y].cuotaTributaria != null) {
            let cuotaTributaria = {};
            Object.assign(cuotaTributaria, PERIODO_CUOTA_INIT);
            cuotaTributaria.id =
              this.periodos[x].idBaseCo +
              '-' +
              this.periodos[x].id +
              '-' +
              this.periodos[x].cuotas[y].id;
            cuotaTributaria.idCuota = this.periodos[x].cuotas[y].id;
            cuotaTributaria.tipo = this.periodos[x].cuotas[y].tipo;
            cuotaTributaria.cuotaTributaria = this.periodos[x].cuotas[y].cuotaTributaria;
            cuotaTributaria.idBaseCo = this.periodos[x].idBaseCo;
            cuotaTributaria.periodoConsumo = this.periodos[x].periodoConsumo;
            cuotaTributaria.facturacion = this.periodos[x].facturacion || 0;
            cuotaTributaria.nukwhfac = this.periodos[x].nukwhfac || 0;
            cuotaTributaria.baseImponible = this.periodos[x].baseImponible;
            this.form.cuotasDeclaracion.push(cuotaTributaria);
          }
        }
      }

      // Para cada cuota calculamos el total en base a los periodos introducidos
      for (let res of this.form.resumenes) {
        // Se calcula el total de las cuotas.
        res.total = this.periodos.reduce((total, item) => {
          let cuotaPeriodo = item.cuotas.filter(item => item.id === res.id && item.cuotaTributaria);

          let totalCuotaPeriodo = cuotaPeriodo.reduce((total, item) => {
            return total + item.cuotaTributaria;
          }, 0);

          return total + totalCuotaPeriodo;
        }, 0);
        res.total = Math.round10(res.total, -2);
        // Se calcula el importe referente al IVA
        let tipo = res.iva || 0;
        res.importeIva = Math.round10((res.total * tipo) / 100, -2);

        // Se calcula el importe a ingresar
        res.totalIngresar = Math.round10(res.total + res.importeIva, -2);
      }
    },
    onSubmitAviso() {
      this.showAlert = true;
    },
    onSubmit() {
      this.setLoading(true);
      this.showAlert = false;
      newDeclaracion(JSON.stringify(this.form))
        .then(response => {
          this.$router.push({
            name: 'justificante',
            params: { cdregist: response.data.cdregist, nujustas: response.data.nujustas }
          });
        })
        .catch(error => {
          notificarError(this, error);
        })
        .then(() => {
          this.setLoading(false);
        });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/resources/styles/variables.scss';
.v-form > .container > .layout > .flex {
  padding: 8px;
}

.ayuda {
  margin: 0px;
  font-size: 0.875rem;
  font-weight: bold;
  width: 100%;
}
</style>
